import { Component, Element, Prop, Host, h } from '@stencil/core';
import { Color } from '../../../interface';
import { createColorClasses } from '../../../utils/theme';

@Component({
  tag: 'lar-list-item',
  styleUrl: 'list-item.scss',
  shadow: true
})

export class ListItem {
  @Element() el!: HTMLElement;

  @Prop() color?: Color;
  /**
   * If `true`, the user cannot interact with the toggle. Defaults to `false`.
   */
  @Prop() disabled = false;

  render() {
    return (
      <Host class={{ ...createColorClasses(this.color), 'lar-item-disabled': this.disabled }}>
        <slot name="start" />
        <div class="item-inner"><slot /></div>
        <slot name="end"/>
      </Host>
    );
  }
}
